import { useBrowseLabel } from '@aibees/elephant/hooks/labels/use-browse-label';
import {
  LabelGrouping,
  LabelType,
  LabelVisibility,
} from '@aibees/elephant/types/label';
import { useQueryStringState } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo, useEffect } from 'react';
import { useSearchListCardStore } from '../../store';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { LabelTableProps as Props } from './types';

export const LabelTable = memo(({ className }: Props) => {
  const { grouping, name, visibility, setEmpty, setIsLoading } =
    useSearchListCardStore();
  const { params } = useQueryStringState();
  const type = LabelType.LABEL;
  const sortValue = `${params.sortField ?? 'modified'}:${
    params.sortOrder ?? 'desc'
  }`;

  const browseApi = useBrowseLabel({
    size: 5,
    type,
    name: name as string,
    visibility: visibility as unknown as LabelVisibility,
    grouping: grouping as LabelGrouping,
    sort: sortValue,
  });

  useEffect(() => {
    setEmpty(browseApi.data?.empty);
    setIsLoading(browseApi.isLoading);
  }, [browseApi.data?.empty, browseApi.isLoading]);

  return (
    <Styled.Wrapper
      className={classnames('LabelTable', className)}
      sx={SX.root}
      config={{
        ...config,
        browseApi: {
          data: browseApi.data?.content.slice(0, 4),
          isLoading: browseApi.isLoading,
        },
      }}
    />
  );
});

LabelTable.displayName = 'LabelTable';
